export const MenuCollapseIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6V8H16V6H3ZM13 13H3V11H13V13ZM16 18H3V16H16V18ZM17.43 12L21.01 15.59L19.6 17L14.6 12L19.6 7L21.01 8.41L17.43 12Z"
      fill="white"
    />
  </svg>
);

export default MenuCollapseIcon;
